export type LicenseKindType = 'SUBSCRIPTION' | 'ONE_TIME_PURCHASE' | 'FREE';
